import { gql } from '@apollo/client';
import * as React from 'react';
import Image from 'next/image';
import { displayPhoneNumber } from 'src/utils/utils';
import { RequestAppointmentHeaderFragment } from './__generated__/RequestAppointmentHeader.generated';
import Link from 'next/link';

export interface IRequestAppointmentHeaderProps {
  metadata: RequestAppointmentHeaderFragment | undefined;
}

export const RequestAppointmentHeader: React.FunctionComponent<
  IRequestAppointmentHeaderProps
> = ({ metadata }) => {
  return (
    <div className='m-5 flex max-w-4xl justify-between md:mx-auto'>
      <div>
        {metadata && (
          <div className='flex flex-col'>
            <div className='font-semibold text-foreground'>
              {metadata.companyName}
            </div>
            {metadata.phoneNumber && (
              <div className='text-sm font-semibold text-muted-foreground'>
                {displayPhoneNumber(metadata.phoneNumber)}
              </div>
            )}
            {metadata.email && (
              <a
                href={`mailto:${metadata.email}`}
                className='text-sm font-semibold text-muted-foreground'
              >
                {metadata.email}
              </a>
            )}
            {metadata.companyWebsite && (
              <Link
                href={metadata.companyWebsite}
                className='text-sm font-semibold text-muted-foreground'
              >
                {metadata.companyWebsite}
              </Link>
            )}

            <div className='mt-5 text-sm text-foreground'>
              <div>
                {metadata.addressLine1 && <span>{metadata.addressLine1}</span>}
                {metadata.addressLine2 && (
                  <span className='flex'>{metadata.addressLine2}</span>
                )}
              </div>
              <div>
                {[metadata.locality, metadata.country, metadata.postalCode]
                  .filter(Boolean)
                  .join(', ')}
              </div>
            </div>
          </div>
        )}
      </div>
      {metadata?.logoUrl && (
        <Image
          unoptimized
          src={metadata?.logoUrl}
          width={100}
          height={100}
          alt={'Company logo'}
          className='h-16 w-16 rounded border ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
          tabIndex={0}
          objectFit='contain'
        />
      )}
    </div>
  );
};

const fragement = gql`
  fragment RequestAppointmentHeader on RequestAppointmentPageMetadata {
    email
    companyName
    companyWebsite
    phoneNumber
    addressLine1
    addressLine2
    locality
    postalCode
    country
    logoUrl
  }
`;
